import Box from '@mui/material/Box';
import { camelCaseToHuman } from '../../../utils/utils';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock, MetaLine } from '../activityFeedHeaderShared';

function IdentificationHeader({ entity, item, activity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity?.name} activity={activity} linkProps={linkProps} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {entity.remediationAction && <MetaLine>{`Action: ${camelCaseToHuman(entity.remediationAction, { preserveAcronyms: false })}`}</MetaLine>}
          <DescriptionSecondary item={item} />
        </Box>
      }
    />
  );
}

export default IdentificationHeader;
